import { render, staticRenderFns } from "./NotificationDropdown.vue?vue&type=template&id=3c0fe35c&"
import script from "./NotificationDropdown.vue?vue&type=script&lang=js&"
export * from "./NotificationDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c0fe35c')) {
      api.createRecord('3c0fe35c', component.options)
    } else {
      api.reload('3c0fe35c', component.options)
    }
    module.hot.accept("./NotificationDropdown.vue?vue&type=template&id=3c0fe35c&", function () {
      api.rerender('3c0fe35c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/app-navbar/components/NotificationDropdown.vue"
export default component.exports